<template>
  <div>
    <div id="Home" class="d-flex justify-content-evenly">
      <div class="col-5">
        <h1 class="text-center">Vaksin</h1>
        <p>
          Vaksin adalah jalan paling ampuh untuk mencegah virus yang menular.
          Video di bawah menjelaskan bagaimaan cara vaksin bekerja, apa yang mereka kandung, dan efek samping umum yang dapat terjadi.
        </p>
        <iframe
          class="youtube-home position-relative your-centered-div"
          align="center"
          src="https://www.youtube.com/embed/-UJ_LBVS8qU"
        >
        </iframe>
        <p class="mt-3">
          Apakah adil jutaan orang dalam negara berpenghasilan tinggi telah menerima sebagian besar vaksin sebelum negara lain?
          di dunia yang adil, selama masa darurat kesehatan dunia, melindungi yang rentan dan mennyelamatkan nyawa harus dalam satu kesatuan. Kita bisa menjadi bagian untuk mengurangi penyebaran virus untuk semuanya.
        </p>
        <div class="mt-3">
          <p>
            <span style="color: blue; font-weight: bold; font-style: italic">
              Sebagai tenaga kesehatan,</span
            >
            apa yang harus kita lakukan?
          </p>
          <ol style="font-weight: bold; font-style: italic">
            <li>Menyiapkan vaksin</li>
            <li>Mengatur jadwal vaksinasi</li>
            <li>Menyebarkan berita kebenaran</li>
          </ol>
        </div>
      </div>
      <img src="../assets/images/Vaccine-rafiki.svg" alt="" />
    </div>

    <h4 class="text-center" style="margin-top: 50px; text-decoration: underline #97D5FC; text-underline-position: under;">Konten terkait</h4>
    <div id="home-related" style="margin-top: 50px">
      <div class="d-flex justify-content-evenly">
        <div class="card" style="width: 18rem">
          <img
            src="../assets/images/A whole year-rafiki.svg"
            class="card-img-top"
          />
          <div class="card-body">
            <a href="https://www.ncbi.nlm.nih.gov/pmc/articles/PMC4927017/" class="card-text">
              Megatur jadwal proses vaksinasi dengan variasi pada umur dan jenis vaksin
            </a>
          </div>
        </div>
        <div class="card" style="width: 18rem">
          <img
            src="../assets/images/Medical research-rafiki.svg"
            class="card-img-top"
          />
          <div class="card-body">
            <a href="https://www.hospitalitynet.org/opinion/4106567.html" class="card-text">
              Mempersiapkan Pertemuan dan Acara yang Aman, Efisien, dan Produktif di Dunia yang tervaksinasi
            </a>
          </div>
        </div>
        <div class="card" style="width: 18rem">
          <img
            src="../assets/images/Typing-rafiki.svg"
            class="card-img-top"
            alt="..."
          />
          <div class="card-body">
            <a href="https://www.unidosus.org/issues/health/covid19/?gclid=CjwKCAiAtdGNBhAmEiwAWxGcUhXg8egbl3py3IxCQxDTdTDDx-jU386Wsx5eSaR5k2zjhMfTsh9LdhoCTrsQAvD_BwE" class="card-text">
              Menyebarkan informasi. Untuk memepeorleh pemulihan masa pandemi yang kita inginkan, kita harus memastikan setiap orang terlibat di dalamnya.
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
};
</script>
